import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";

const WhiteListPage = () => {
  const navigate = useNavigate();
  const pathname = useLocation().pathname;
  const auth = !!localStorage.getItem("TOKEN");
  if (!auth && (pathname === "/" || pathname === "")) {
    setTimeout(()=>{
      navigate("/login");
    })
  }
  return <div>{!auth ? <Outlet /> : <Navigate to="/" />}</div>;
};

export default WhiteListPage;
